<div [formGroup]="form">
  <mat-form-field *ngIf="materialBrand" appearance="fill" class="w-full">
    <mat-label>Marca de Material</mat-label>
    <mat-select formControlName="materialBrandId" placeholder="Seleccione una marca" multiple>
      <mat-option *ngFor="let brand of materialBrandList" [value]="brand.code">
        <div>
          <b class="f-9" *ngIf="getCode(brand) as code">{{ code }}</b>
        </div>
        {{ brand.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="materialGroup && !isMultiple" appearance="fill" class="w-full">
    <mat-label>Grupo de materiales</mat-label>
    <mat-select formControlName="materialGroupId" placeholder="Seleccione Grupo de Materiales"
      panelClass="select-panel-with-search" (selectionChange)="fetchMaterials()">

      <mat-option>
        <ngx-mat-select-search [(ngModel)]="materialGroupSearch" [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Buscar grupo de materiales..." noEntriesFoundLabel="No se encontraron resultados"
          (ngModelChange)="filterMaterialGroupList($event)">
        </ngx-mat-select-search>
      </mat-option>

      <mat-option *ngFor="let type of filteredMaterialGroupList" [value]="type.code">
        <div>
          <b class="f-9" *ngIf="getCode(type) as code">{{ code }}</b>
        </div>
        {{ type.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="materialGroup && isMultiple" appearance="fill" class="w-full">
    <mat-label class="block text-gray-700 border-gray-300 pb-[2px] mb-[4px]">Grupo de Materiales</mat-label>
    <mat-select formControlName="materialGroupId" multiple placeholder="Seleccione Grupo de Materiales"
      panelClass="select-panel-with-search" (selectionChange)="fetchMaterials()">

      <mat-select-trigger>
        {{ getDisplayValue(materialGroupList, form.get('materialGroupId')?.value, "name") }}
      </mat-select-trigger>

      <mat-option>
        <ngx-mat-select-search [(ngModel)]="materialGroupSearch" [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Buscar grupo de materiales..." noEntriesFoundLabel="No se encontraron resultados"
          (ngModelChange)="filterMaterialGroupList($event)">
        </ngx-mat-select-search>
      </mat-option>

      <!-- Opciones filtradas -->
      <mat-option *ngFor="let type of filteredMaterialGroupList" [value]="type.code">
        <div>
          <b class="f-9" *ngIf="getCode(type) as code">{{ code }}</b>
        </div>
        {{ type.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="materialGroupWithMongoId && isMultiple" appearance="fill" class="w-full">
    <mat-label class="block text-gray-700 border-gray-300 pb-[2px] mb-[4px]">Grupo de Materiales</mat-label>
    <mat-select formControlName="materialGroupId" multiple placeholder="Seleccione Grupo de Materiales"
      panelClass="select-panel-with-search" (selectionChange)="fetchMaterials()">

      <mat-select-trigger>
        {{ getDisplayValue(materialGroupList, form.get('materialGroupId')?.value, "name") }}
      </mat-select-trigger>

      <mat-option>
        <ngx-mat-select-search [(ngModel)]="materialGroupSearch" [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Buscar grupo de materiales..." noEntriesFoundLabel="No se encontraron resultados"
          (ngModelChange)="filterMaterialGroupList($event)">
        </ngx-mat-select-search>
      </mat-option>

      <!-- Opciones filtradas -->
      <mat-option *ngFor="let type of filteredMaterialGroupList" [value]="type._id">
        <div>
          <b class="f-9" *ngIf="getCode(type) as code">{{ code }}</b>
        </div>
        {{ type.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Grupo de Materiales (único o múltiple según isMultiple) -->
  <!-- <mat-form-field  *ngIf="materialGroup" appearance="fill" class="w-full">
    <mat-label class="block text-gray-700 border-gray-300 pb-[2px] mb-[4px]">Grupo de Materialses</mat-label>
    <mat-select formControlName="materialGroupId" [multiple]="isMultiple" placeholder="Seleccione Grupo de Materiales"
      (selectionChange)="fetchMaterials()" panelClass="select-panel-with-search">
      <mat-select-trigger *ngIf="isMultiple">
        {{ getDisplayValue(materialGruopList, form.get('materialGroupId')?.value, "name") }}
      </mat-select-trigger>

      <mat-option disabled class="p-0">
        <ngx-mat-select-search
          [(ngModel)]="materialGroupSearch"
          [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Buscar grupo de materiales..."
          noEntriesFoundLabel="No se encontraron resultados"
          (ngModelChange)="filterMaterialGroupList($event)">
        </ngx-mat-select-search>
      </mat-option>

      <mat-option *ngFor="let type of filteredMaterialGroupList" [value]="type.code">
        {{ type.name }}
      </mat-option>
    </mat-select>
  </mat-form-field> -->

  <!-- Materiales -->
  <mat-form-field *ngIf="material" appearance="fill" class="w-full">
    <mat-label class="block text-gray-700 border-gray-300 pb-[2px] mb-[4px]">Materiales</mat-label>
    <mat-select formControlName="materialId" multiple placeholder="Seleccione Materiales"
      panelClass="select-panel-with-search">
      <mat-select-trigger>
        {{ getDisplayValue(materialList, form.get('materialId')?.value, "name") }}
      </mat-select-trigger>

      <mat-option>
        <ngx-mat-select-search [(ngModel)]="materialSearch" [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Buscar materiales..." noEntriesFoundLabel="No se encontraron resultados"
          (ngModelChange)="filterMaterialList($event)">
        </ngx-mat-select-search>
      </mat-option>

      <!-- Opciones filtradas -->
      <mat-option *ngFor="let type of filteredMaterialList" [value]="type.code">
        <div>
          <b class="f-9" *ngIf="getCode(type) as code">{{ code }}</b>
        </div>
        {{ type.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="materialWithMongoId" appearance="fill" class="w-full">
    <mat-label class="block text-gray-700 border-gray-300 pb-[2px] mb-[4px]">Materiales</mat-label>
    <mat-select formControlName="materialId" multiple placeholder="Seleccione Materiales"
      panelClass="select-panel-with-search">
      <mat-select-trigger>
        {{ getDisplayValue(materialList, form.get('materialId')?.value, "name") }}
      </mat-select-trigger>

      <mat-option>
        <ngx-mat-select-search [(ngModel)]="materialSearch" [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Buscar materiales..." noEntriesFoundLabel="No se encontraron resultados"
          (ngModelChange)="filterMaterialList($event)">
        </ngx-mat-select-search>
      </mat-option>

      <!-- Opciones filtradas -->
      <mat-option *ngFor="let type of filteredMaterialList" [value]="type._id">
        <div>
          <b class="f-9" *ngIf="getCode(type) as code">{{ code }}</b>
        </div>
        {{ type.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>